import { render, staticRenderFns } from "./vesselForm.vue?vue&type=template&id=0a595900&scoped=true&"
import script from "./vesselForm.vue?vue&type=script&lang=js&"
export * from "./vesselForm.vue?vue&type=script&lang=js&"
import style0 from "./vesselForm.vue?vue&type=style&index=0&id=0a595900&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a595900",
  null
  
)

export default component.exports